import { useCourseProgressStore } from '@/infrastructure/store/courseProgressStore';

export const useCourseProgress = () => {
  const store = useCourseProgressStore();
  return {
    progressByCourseId: store.progressByCourseId,
    progressStatus: store.status,
    progressError: store.error,
    fetchProgress: store.fetchProgress,
    saveProgress: store.saveProgress,
    clearProgress: store.clearProgress,
  };
};
